import siteApi from '../clients/site';

export const generateSiteSearchKey = async (): Promise<string> => {
  const { data } = await siteApi.post<string>('/generate-search-key');

  return data;
};
